/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_DocsInputs */

const en_support_docs = /** @type {(inputs: Support_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the docs`)
};

const id_support_docs = /** @type {(inputs: Support_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baca dokumentasi`)
};

/**
* | output |
* | --- |
* | "Read the docs" |
*
* @param {Support_DocsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const support_docs = /** @type {((inputs?: Support_DocsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_DocsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_support_docs(inputs)
	return en_support_docs(inputs)
});